import {
  APP_COLOR,
  APP_HOVER_COLOR,
  FONT_FAMILY,
  INITIAL_SETTINGS_BACKGROUND_COLOR,
  SKIP_BUTTON_BACKGROUND_COLOR,
  SKIP_BUTTON_TEXT_COLOR,
  TEXT_COLOR,
  THEME,
  lightenDarkenColor,
} from "../../theme";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  customOption: {
    backgroundColor: INITIAL_SETTINGS_BACKGROUND_COLOR,
    "&:hover": {
      backgroundColor:
        THEME === "dark"
          ? "#202425"
          : lightenDarkenColor(INITIAL_SETTINGS_BACKGROUND_COLOR, -20),
      cursor: "pointer",
    },
    padding: "5px",
    paddingLeft: "10px",
  },
  customTextField: {
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
}));

export const userDetailsStageStyles = {
  formGroup: {
    width: "110%",
    marginTop: "15px"
  } as const,
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: '20px'
  } as const,
  childOfMainComponent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  logoImage: {
    width: "200px",
    height: "50px",
    marginTop: "15px",
    marginBottom: "15px",
  } as const,
  textFieldContainer: {
    width: "110%",
    marginTop: "20px",
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    "&:disabled": { backgroundColor: "grey" },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
    marginTop: "10px",
  } as const,
  indicatorContainer: {
    width: "120%",
    marginTop: "25px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
  } as const,
  indicatorDot: {
    border: `1px solid ${TEXT_COLOR}`,
    width: "12px",
    height: "12px",
    borderRadius: "10px",
    "&:hover": {
      cursor: "pointer",
    },
  } as const,
  textField: {
    marginTop: "5px",
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        boxShadow:
          "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
      },
    },
  } as const,
};

export const preferencesStageStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: '20px'
  } as const,
  childOfMainComponent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  logoImage: {
    width: "200px",
    height: "50px",
    marginTop: "15px",
    marginBottom: "15px",
  } as const,
  textFieldContainer: {
    width: "380px",
    marginTop: "20px",
    padding: window.innerWidth < 429 ? "0 10px" : 0,
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
    marginTop: "10px",
  } as const,
  skipButton: {
    borderRadius: "var(--radius-md, 8px)",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    textTransform: "none",
  } as const,
  indicatorContainer: {
    width: "120%",
    marginTop: "25px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
  } as const,
  indicatorDot: {
    border: `1px solid ${TEXT_COLOR}`,
    width: "12px",
    height: "12px",
    borderRadius: "10px",
    "&:hover": {
      cursor: "pointer",
    },
  } as const,
  list: {
    fontFamily: FONT_FAMILY,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  } as const,
  buttonsContainer: {
    width: "380px",
    marginTop: "15px",
    padding: window.innerWidth < 429 ? "0 10px" : 0,
  } as const,
};

export const personalInformationStageStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px"
  } as const,
  childOfMainComponent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  logoImage: {
    width: "200px",
    height: "50px",
    marginTop: "15px",
    marginBottom: "15px",
  } as const,
  textFieldContainer: {
    width: "380px",
    marginTop: "20px",
    padding: window.innerWidth < 429 ? "0 10px" : 0,
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
    marginTop: "10px",
  } as const,
  skipButton: {
    borderRadius: "var(--radius-md, 8px)",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    textTransform: "none",
  } as const,
  indicatorContainer: {
    width: "120%",
    marginTop: "25px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
  } as const,
  indicatorDot: {
    border: `1px solid ${TEXT_COLOR}`,
    width: "12px",
    height: "12px",
    borderRadius: "10px",
    "&:hover": {
      cursor: "pointer",
    },
  } as const,
  imageUploadInput: {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  } as const,
  imageUploadInputContainer: {
    position: "relative",
    overflow: "hidden",
    border: "1px solid gray",
    height: "120px",
    width: "100%",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  profilePicContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    marginBottom: "10px",
  } as const,
  textField: {
    marginTop: "5px",
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        boxShadow:
          "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
      },
    },
  } as const,
  buttonsContainer: {
    width: "380px",
    marginTop: "15px",
    padding: window.innerWidth < 429 ? "0 10px" : 0,
  } as const,
};

export const stageStyles = {
  title: {
    alignSelf: "stretch",
    fontFamily: "Argumentum",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
  } as const,
  description: {
    fontFamily: "Argumentum",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    alignSelf: "stretch",
  } as const,
};
